export default {
  FAQ: {
    TITLE: 'Frequently Asked Question',
    QUESTIONS: {
      Q1: 'Produk buatan mana Hikarusa?',
      Q2: 'Bagaimana cara membeli produk Hikarusa?',
      Q3: 'Apakah Hikarusa dapat mengirim produknya ke luar negeri?',
      Q4: 'Perlukah mencuci produk baru Hikarusa?',
      Q5: 'Cara merawat produk Hikarusa?',
      Q6: 'Apakah bantal dan guling boleh saya cuci?',
      Q7: 'Kenapa isi bantal atau guling saya menggumpal?',
      Q8: 'Bagaimana jika isian bantal dan guling yang menggumpal?',
      Q9: 'Bagaimana jika isian bantal dan guling mulai kempis?',
      Q10: 'Amankah produk Hikarusa untuk baby?',
      Q11: 'Hikarusa terbuat dari apa?',
      Q12: 'Apakah warna Hikarusa aman dan akan luntur?',
      Q13: 'Ukuran rekomendasi Hikarusa untuk saya apa?',
      Q14: 'Apakah Hikarusa tersedia di ecommerce ?',
      Q15: 'Bagimana dengan produk Hikarusa yang bermasalah?',
      Q16: 'Apakah dijual bantal dan guling nya saja?',
      Q17:
        'Amankah jika bendera pada guling Hikarusa digigit atau dimasukan ke mulut oleh anak?',
      Q18: 'Bagaimana jika bantal guling saya terkena pipis, gumoh, kotoran?',
      Q19: 'Stock apakah yang tersedia?',
      Q20: 'Bolehkah teteskan essential oil pada produk Hikarusa?',
      Q21: 'Apakah Hikarusa perlu di setrika?',
      Q22: 'Hikarusa saya berbulu bagaimana cara atasinya?',
      Q23: 'Plastik vakum saya mengembang apakah produk ini bekas?',
      Q24: 'Ingin tukar produk dengan motif atau produk lainnya?',
      Q25: 'Pendaftaran menjadi reseller, distributor Hikarusa?',
      Q26: 'Size detail produk Hikarusa?',
      Q27: 'Pengiriman produk Hikarusa ke kota saya bisa ?',
      Q28: 'Apa akun resmi Hikarusa?'
    },
    ANSWERS: {
      A1:
        'Hikarusa group adalah produk lokal dari Indonesia, buatan hasil karya anak bangsa.',
      A2:
        'Produk Hikarusa bisa didapatkan melalui reseller, distributor, website resmi Hikarusa dan ecommerce di Indonesia.',
      A3:
        'Kami memiliki reseller di beberapa negara diluar Indonesia, dan beberapa reseller kami dapat mengirimkan produk Hikarusa ke luar negeri (melalui Shopee International), untuk info lebih lanjut bisa bertanya pada reseller kami.',
      A4:
        'Pada produk baru sarung boleh dicuci, untuk bantal dan gulingnya cukup dijemur atau divakum menggunakan vakum kering.',
      A5:
        'Jauhkan dari air, lingkungan yang lembab dan benda berbau tajam. Cukup jemur dibawah terik matahari setidaknya seminggu sekali dan hanya cuci sarungnya saja jika sudah kotor. Selalu lap menggunakan lap kering/tissue jika bayi mudah berkeringat, dan jemur setelahnya',
      A6:
        'Kami tidak merekomendasikan dicuci terkecuali produk tersebut kotor dan perlu di cuci menggunakan air, dengan catatan isian dapat menggumpal.',
      A7:
        'Isian menggumpal dikarenakan basah yang dapat berasal dari keringat, tertumpah air, udara yang lembab dan dingin.',
      A8:
        'Jika isi sudah menggumpal sulit untuk Kembali ke bentuk semula, masih boleh dipakai selama masih nyaman untuk digunakan. Kami sarankan untuk rajin menjemur setelah pemakaian',
      A9:
        'Tepuk tepuk dengan tangan bantal dan guling beberapa kali, tarik perlahan isian bantal atau guling yang tanpa sarung pada sisi (bukan pada sisi jahitan) lalu tepuk tepuk kembali.Lakukan setidaknya 1-2 kali setiap bulan.',
      A10:
        'Sangat aman, karena berbahan TENCEL™ bersifat hypoallergenic dan microfiber bersertifikat STANDARD 100 by OEKO-TEX® (sertifikasi bebas bahan kimia berbahaya).',
      A11:
        'Kain Hikarusa menggunakan TENCEL™ dan Spandex, untuk isi berupa bulu angsa sintetis (microfiber) yang bersertifikat STANDARD 100 by OEKO-TEX®',
      A12:
        'Hikarusa menggunakan tinta water based (berbahan dasar air) yang aman untuk kulit, serat kain TENCEL™ membuat warna akan tetap aman tidak akan luntur.',
      A13:
        'Newborn – 1 Tahun = Small Size, 1 – 2 Tahun = Medium Size, 3-5 Tahun= Large Size, 5 Tahun- Dewasa= Jumbo Size. Untuk size kembali kepada kenyamanan pengguna masing masing.',
      A14:
        'Hikarusa bisa didapatkan di ecommerce seperti Shopee, Tokopedia, Lazada, Blibli, Bukalapak, JD.ID, dan ecommerce lainnya.',
      A15:
        'Silahkan hubungi dengan penjual yang terkait dengan transaksi anda. Laporan atau pengaduan ke pusat hanya khusus transaksi melalui website resmi Hikarusa.',
      A16:
        'Kami menjual bantal dan guling Hikarusa nya tanpa sarung khusus untuk yang sudah memiliki produk Hikarusa.',
      A17:
        'Aman dan sebaiknya di keringkan jika sudah basah, selalu perhatikan juga jika ada robek pada kain Hikarusa.',
      A18:
        'Kami rekomendasikan untuk segera di cuci jika sudah sangat kotor dengan catatan isian dapat menggumpal, video tutorialnya bisa dilihat di Instagram atau Youtube Hikarusa.',
      A19:
        'Untuk perihal stock tersedia mohon untuk konfirmasi pada penjual atau reseller tersebut.',
      A20:
        'Boleh asalkan tidak membuat hingga basah, tapi kami sarankan untuk dicampurkan tidak essential oil murni 100%, karena dapat membuat produk menjadi warna kuning.',
      A21:
        'Setelah pencucian sarung cukup dikeringkan saja, tidak perlu disetrika menggunakan setrika biasa ataupun uap. Untuk pajamas boleh disetrika tapi tidak dengan suhu yang tinggi.',
      A22:
        'Gunakan lint remover jika terganggu dengan lint (bulu) yang berada pada sarung, kain dapat muncul lint atau bulu dikarenakan sifat alami kain yang halus memiliki rongga cukup lebar. Muncul lint tergantung pada pemakaian masing masing.',
      A23:
        'Vakum yang mengembang adalah hal yang wajar, dikarenakan banyak faktor dipengiriman dapat membuat vakum mengembang. Selama tidak ada cacat pada produk dan vakum kami pastikan produk masih aman.',
      A24:
        'Penukaran produk tergantung pada ketentuan penjual/reseller masing masing, kami tidak menerima penukaran produk jika telah digunakan.',
      A25:
        'Untuk saat ini hanya ada Official Reseller, Reseller, Dropship Hikarusa, jika tertarik silahkan hubungi Official Distributor kami untuk info lebih lanjut.',
      A26:
        'Ukuran detil tentang produk Hikarusa bisa dicek di Instagram Hikarusa dan website pada bagian produk.',
      A27:
        'Hikarusa dapat mengirim ke dalam negeri (seluruh Indonesia) dan luar negeri.',
      A28: 'Instagram: @HikarusaBaby , website: www.HikarusaGroup.com'
    }
  }
}
